<template>
  <div>
    <div v-show="isAboutMe" style="max-width: 1500px; min-width: 1200px;width: 100%;margin: 0 auto">
      <img style="width: 100%;"
           :src="brand_story.about_us" alt="">
    </div>
    <div v-show="isExchange" class="content">
      <img style="width: 100%;"
           :src="brand_story.exchange" alt="">
    </div>
    <div v-show="isVip" class="content">
      <img style="width: 100%;"
           :src="brand_story.vip" alt="">
    </div>
    <div v-show="isAboutBoss" class="content">
      <img style="width: 100%;"
           :src="brand_story.boss" alt="">
    </div>
    <div v-show="isAboutHonor" class="content">
      <img style="width: 100%;"
           :src="brand_story.honor" alt="">
    </div>
    <div v-show="isAboutHistory" class="content">
      <img style="width: 100%;"
           :src="brand_story.history" alt="">
    </div>
    <div v-show="isJoinUs" class="content">
      <img style="width: 100%;"
           :src="brand_story.join_us" alt="">
    </div>


  </div>
</template>

<script>
  export default {
    name: "BrandStory",
    data() {
      return {
        isAboutMe: false,
        isExchange: false,
        isVip: false,
        isAboutBoss: false,
        isAboutHonor: false,
        isAboutHistory: false,
        isJoinUs: false,
        brand_story:{
          about_us: '',
          exchange: '',
          vip: '',
          boss: '',
          honor: '',
          history: '',
          join_us:''
        }
      }
    },
    methods: {
      initBrandStoryImg() {
        var baseUrl = 'https://ssh-prod-public.oss-cn-shenzhen.aliyuncs.com/mall/';
        //todo 英文版图片好了在换
        // var spand = this.$i18n.locale === 'en' ? '_en' : '';
        var spand =  '';
        this.brand_story.about_us = baseUrl + 'about_us' + spand + '.png';
        this.brand_story.exchange = baseUrl + 'brand_story_exchange' + spand + '.png';
        this.brand_story.vip = baseUrl + 'vip' + spand + '.png';
        this.brand_story.boss = baseUrl + 'about_boss' + spand + '.png';
        this.brand_story.honor = baseUrl + 'about_honor' + spand + '.png';
        this.brand_story.history = baseUrl + 'about_history' + spand + '.png';
        this.brand_story.join_us = baseUrl + 'join_us' + spand + '.png';
      },
      resetImage() {
        this.isAboutMe = false;
        this.isJoinUs = false;
        this.isVip = false;
        this.isExchange = false;
        this.isAboutBoss = false;
        this.isAboutHonor = false;
        this.isAboutHistory = false;
      },
      initImage() {
        switch (this.$route.query.type) {
          case 'about_us':
            this.isAboutMe = true;
            break
          case 'join_us':
            this.isJoinUs = true;
            break
          case 'vip':
            this.isVip = true;
            break
          case 'exchange':
            this.isExchange = true;
            break
          case 'about_boss':
            this.isAboutBoss = true;
            break
          case 'about_honor':
            this.isAboutHonor = true;
            break
          case 'about_history':
            this.isAboutHistory = true;
            break
        }
      }
    },
    created() {
      this.resetImage();
      this.initImage();
    },
    mounted() {
      this.initBrandStoryImg();
    }
  }
</script>

<style scoped>
  .content {
    max-width: 1200px;
    margin: 0px auto;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/viewHK/BrandStory.vue